import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material';
import { ReactComponent as ForwardRef } from '../../../assets/icons/CloseNevativeSmall.svg.js';
import Input from '../../Input/Input.js';
import { useMultiSelect } from '../context/MultiSelectProvider.js';
import useFocusOnSearch from '../hooks/useFocusOnSearch.js';

const Root = styled(MuiBox) `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => `
    padding: ${theme.spacing(1.5, 3)};
  `}
`;
const _CleanIcon = styled(ForwardRef) `
  position: absolute;
  right: 15px;
  cursor: pointer;
  ${({ theme }) => `
    color: ${theme.palette.N20.main};
    &:hover {
      color: ${theme.palette.primary.main};
    }
  `}
`;
const _Input = styled(Input) `
  width: 100%;
  ${({ theme }) => `
    color: ${theme.palette.N05.main};
    &.Mui-focused {
      color: ${theme.palette.N05.main};
      background-color: ${theme.palette.N70.main};
      &:before {
        border-color: transparent !important;
      }
    }
  `}
`;
const INPUT_PROPS = {
    'data-testid': 'multi-select-searchbar',
    onMouseDown: e => {
        e.stopPropagation();
        // @ts-ignore
        e.target.focus();
    },
    onTouchEnd: e => {
        e.stopPropagation();
        // @ts-ignore
        e.target.focus();
    },
};
const SearchBar = () => {
    const searchRef = useRef(null);
    const { search, onMenuFocus } = useMultiSelect();
    useFocusOnSearch(searchRef);
    if (!search) {
        return null;
    }
    return (jsxs(Root, { children: [jsx(_Input, { value: search.value, placeholder: search.placeholder, ref: searchRef, onChange: e => search.onChange(e.target.value), onKeyDown: e => e.stopPropagation(), onKeyPress: e => e.stopPropagation(), onFocus: onMenuFocus, inputProps: INPUT_PROPS }), search.value && jsx(_CleanIcon, { onClick: () => search.onChange('') })] }));
};

export { SearchBar as default };
//# sourceMappingURL=SearchBar.js.map
